import { createSelector } from 'reselect';
import { reduxKey } from './constants';
function getSlice(state) {
    if (!state[reduxKey]) {
        return {};
    }
    return state[reduxKey];
}
export const getEnv = createSelector(getSlice, (slice)=>{
    return slice;
});

//# sourceMappingURL=selectors.js.map